import React from 'react';

import { NoHsaPlanSelected } from 'Containers/HsaPage/styled';
import { useTextContext } from 'Contexts/textContext';
import { Button } from 'DesignLibrary/atoms';

interface NoPlanSelectedProps {
  handleGoToHealth: () => void;
  handleNext: () => void;
}

export const NoPlanSelected = ({ handleGoToHealth, handleNext }: NoPlanSelectedProps) => {
  const { retrieveContentfulData } = useTextContext();

  const buttonText = retrieveContentfulData<Record<string, string | never>>('hsa.button_text', {});
  const unselectedPlanText = retrieveContentfulData<string>('hsa.unselected_health_plan_text');
  const unselectedPlanSubtext = retrieveContentfulData<string>('hsa.unselected_health_plan_subtext');

  return (
    <NoHsaPlanSelected id="noHsaPlan">
      <h1>{unselectedPlanText}</h1>
      <h4>{unselectedPlanSubtext}</h4>
      <div>
        <Button id="back-to-profile-btn" onClick={handleGoToHealth}>
          {buttonText.back}
        </Button>
        <Button id="go-to-next-btn" onClick={handleNext}>
          {buttonText.review}
        </Button>
      </div>
    </NoHsaPlanSelected>
  );
};
